import HttpRequest from "@/api/axios";

const axios = new HttpRequest(process.env.VUE_APP_API_BASE_URL);

export default {
    videocat(data) {
        return axios.request({
            url: "mwap/videocat",
            method: "post",
            data
        });
    },
    pushUpsDetail(data) {
        return axios.request({
            url: "mwap/caloriegame",
            method: "post",
            data
        }).then((res) => {
            if (res.status * 1 === 200) {
                res.data.imgurl = `${res.data.mediaurl}?x-oss-process=video/snapshot,t_5000,f_jpg,w_574,h_355,ar_auto`
            }
            return res;
        });
    },
    calorie(data) {
        return axios.request({
            url: "mwap/submitcalorie",
            method: "post",
            data
        });
    },
    showList(data) {
        return axios.request({
            url: "mwap/compareinfo",
            method: "post",
            data
        });
    },
    videolist(data) {
        return axios.request({
            url: "mwap/videolist",
            method: "post",
            data
        }).then((res) => {
            if (res.status * 1 === 200) {
                let list = res.data
                
                list.forEach((item) => {
                    item.imgurl = `${item.mediaurl}?x-oss-process=video/snapshot,t_5000,f_jpg,w_215,h_125,ar_auto`
                })
                              
            }
            return res;
        });
    },
    pointrank(data) {
        return axios.request({
            url: "mwap/pointrank",
            method: "post",
            data
        });
    },
    videopoint(data) {
        return axios.request({
            url: "mwap/videopoint",
            method: "post",
            data
        });
    }
}